<template lang="pug">
v-dialog(data-cy='register-brand-modal', persistent, :value='value', max-width='750')
  v-card.rounded-card
    title-bar(dark) {{ bannerText }}
    v-card-title.pb-2
      v-layout(row, justify-center)
        v-flex(xs12)
          h3.primary--text.text-xs-center.font-weight-thin.title-pad {{ titleText }}
    v-card-text.pt-2.pb-0
      v-layout(row)
        v-flex(xs12)
          p {{ p1Text }}
          p(v-html="p2Text")
          p {{ p3Text }}
      v-layout.mt-1(column)
        v-flex(v-if="newVersion")
          a2p-register-customer-lite-form(
            :modal-view="true"
            @submit="closeModal()"
          )
        v-flex(v-if="!newVersion" xs12)
          v-layout(row, justify-space-around, wrap)
            v-flex.mt-1(xs12, sm5)
              v-layout(column, align-center)
                v-btn.primary.action-btn.ma-0(@click='goToLiteBrand')
                  v-layout(column)
                    span LITE BRAND
                    span.caption Less than 3k daily messages
            v-flex(xs12, sm5)
              v-layout.mt-1(column, align-center)
                v-btn.primary.action-btn.ma-0(@click='goToStandardBrand')
                  v-layout(column)
                    span STANDARD BRAND*
                    span.caption More than 3k daily messages
                span.primary--text * Fees apply
      v-layout(column, align-center)
        v-flex.mt-3(xs12)
          a.text-xs-center(
            href='https://lonewolf.my.site.com/s/article/LD-What-are-the-A2P-10-DLC-Guidelines-and-how-do-they-affect-my-LionDesk-account',
            target='_blank'
          ) Learn More about the new A2P 10DLC Guidelines
        v-flex.mt-2(xs12)
          a.text-xs-center(v-if='!noSkip', @click='closeModal') Skip this and continue
</template>

<script>
import TitleBar from '@/Core/components/TitleBar';

const a2pRegisterCustomerLiteForm = () =>
  import(/* webpackChunkName: 'a2pRegisterCustomerLiteForm' */ '@/a2p/components/RegisterCustomerLiteForm');

export default {
  name: 'RegisterBrandModal',
  components: {
    TitleBar,
    a2pRegisterCustomerLiteForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    noSkip: {
      type: Boolean,
      default: false,
    },
    newVersion: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    goToLiteBrand() {
      this.$router.push('/a2p-litebrand-registration');
    },
    goToStandardBrand() {
      this.$router.push('/a2p-standardbrand-registration');
    },
    closeModal() {
      this.$emit('close');
    },
  },
  computed: {
    bannerText() {
      return 'CUSTOM NUMBER BRAND REGISTRATION';
    },
    titleText() {
      return 'PLEASE REGISTER YOUR BUSINESS TO CONTINUE TEXTING';
    },
    p1Text() {
      return `Registration is required by major U.S. wireless carriers to ensure ongoing deliverability of your text messages.`;
    },
    p2Text() {
      return `Please complete this short form to register your brand now and continue texting.`;
    },
    p3Text() {
      return '';
    },
  },
};
</script>

<style scoped>
.action-btn {
  height: 60px;
}
.rounded-card {
  border-radius: 10px;
}
.title-pad {
  padding-left: 40px;
  padding-right: 40px;
}
</style>
